export default __webpack_public_path__ + "static/noise-72d84729f5be1073b253f03a04b7c086.png";